<!-- Copyright (c) 2022-2024, NVIDIA CORPORATION & AFFILIATES. All rights reserved. -->

<template>
    <div>
        <transition name="hide">
            <div v-if="closed" id="curtain" class="curtain"></div>
        </transition>
    </div>
</template>
<script>
export default {
    name: 'Curtain',
    props: {
        closed: Boolean,
    },
};
</script>
<style lang="scss" scoped>
@import '~@cumulus/air-ui-kit/variables.scss';

.curtain {
    height: 100%;
    width: 100%;
    position: fixed;
    top: 48px;
    left: 0;
    background-color: $athens-gray;
    z-index: 50;
}
.hide-leave-active {
    transition: opacity .5s;
}
.hide-leave-to {
    opacity: 0;
}
.hide-enter {
    transition: none;
}
</style>
